













import {
  Vue,
  Component,
} from "@/shared/vuepack";
import * as routes from "@/employer/route-names";

@Component
export default class ResourcesNavigation extends Vue {
  routes = routes;
  activeTab = null;

  mounted (): void {
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }
}

